import React , {Component} from 'react';
import Skeleton from 'react-loading-skeleton';
class OrderAddressLoader extends Component{
    render(){
        return(
            <div>
                <div className="row">
                    <div className="col">
                        <Skeleton count={1} height={100}/>
                    </div>
                    <div className="col">
                        <Skeleton count={1} height={100}/>
                    </div>
                </div>
            </div>

        )
    }
}


export default OrderAddressLoader;